import { CHANGE_GLOBAL_CONFIG, IMPORT_STATE, BATCH_SET_SCENE_FONT } from "../common/actions";
import { changeProp } from "../common/utils";
import { globalConfig } from "./serializer";

export const emptyState = {
  title: "IdealStudio",
  canvasRatio: 16 / 9,
  ratio: "16:9",
  visorNav: { player: true, sidebar: true, keyBindings: true },
  trackProgress: true,
  age: { min: 0, max: 100 },
  context: "school",
  rights: "public",
  keywords: [],
  typicalLearningTime: { h: 0, m: 0, s: 0 },
  version: "1.0.0",
  thumbnail: "",
  status: "draft",
  structure: "linear",
  difficulty: "easy",
  jobWidgetVisible: true,
  chatbotOptIn: false,
  allowConfig: true,
  allowDownload: true,
  allowComments: true,
  globalTheme: {
    themeId: "",
    paletteId: "",
    applyToAll: false,
    themeHtml: "",
    themeCssVariables: {},
  },
  defaultSceneMandatory: {
    isMandatory: false,
    mandatoryType: "waitForTime",
    minTime: 0,
    autoNext: false,
    autoNextShowCta: false,
    sceneEndCta: false,
    questionIsMandatory: false,
    questionMandatoryType: "waitForAction",
    questionMinTime: 0,
  },
  defaultSceneDuration: 0,
  initialConfigCompleted: false,
  legacyHeadersMigrated: true,
  subtitlesOnByDefault: false,
};

export default function (state = emptyState, action = {}) {
  switch (action.type) {
    case CHANGE_GLOBAL_CONFIG:
      if (action.payload.prop === "STATE") {
        return action.payload.value;
      }
      return changeProp(state, action.payload.prop, action.payload.value);
    case BATCH_SET_SCENE_FONT:
      // Scene-scoped application (payload carries boxIds) must not move the
      // course default — only "whole course" redefines it.
      if (action.payload.boxIds) return state;
      // Set the course-default font so new scenes inherit it. The per-scene write
      // lives in view_toolbars_by_id (same action). See VERIFY-LIVE note there.
      return changeProp(state, "fontFamily", action.payload.fontFamily);
    case IMPORT_STATE:
      return globalConfig(action.payload.present.globalConfig) || state;
    default:
      return state;
  }
}
